import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { authorizedGuard } from 'src/app/shared/guards/authorized.guard';
import { NewsComponent } from './news.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [authorizedGuard],
    component: NewsComponent,
  },
  {
    path: ':newsItemId',
    canActivate: [authorizedGuard],
    component: NewsComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NewsRoutingModule { }
